import React, { Component } from 'react'

let unmountedStyle = {
    opacity: 0,
    //transform: 'translate3d(500px, 0, 0)',
}
let mountedStyle = {
    opacity: 1,
    transform: 'translate3d(0, 0, 0)',
    transition: 'opacity 1s ease-out, transform 1s ease-out',
}

const withAnimatedMount = (WrappedComponent) =>
    class AnimatedMount extends Component {
        state = {
            style: unmountedStyle,
        }

        componentDidMount() {
            setTimeout(() => {
                this.setState({
                    style: mountedStyle,
                })
            }, 10)
        }

        render() {
            return (
                <div
                    //className={"section-page"}
                    className={'animated-mount-section'}
                    style={this.state.style}
                >
                    <WrappedComponent {...this.props} />
                </div>
            )
        }
    }

export default withAnimatedMount
